export const MAX_JOB_TITLES_ALLOWED = 30;

/** Inclusive lower bound for audience age targeting (`minAge`). */
export const MINIMUM_TARGETING_AGE = 18;

/**
 * Highest `maxAge` audience targeting accepts. Every stored `maxAge`,
 * including this one, is an inclusive cutoff: 75 excludes participants aged
 * 76 and over. A null `maxAge` is the only way to say there is no upper limit.
 *
 * The ceiling is 75 because active participants thin out sharply after that.
 * The legacy `55+` age group is a separate, open-ended bucket.
 */
export const MAXIMUM_TARGETING_AGE = 75;
